<template>
  <section>
    <md-button
      v-if="isDemo"
      class="md-dense md-primary"
      :disabled="!isLoginEnabled"
      @click="loginAndCreateAdminAccount"
      >Create Admin demo account
    </md-button>
  </section>
</template>

<script>
import { eventBus } from "../../eventbus";

export default {
  name: "CreateAdminDialogActions",
  data: function () {
    return {
      emailAddress: null,
      isLoginEnabled: false,
      isDemo: this.$store.state.isDemo,
    };
  },
  methods: {
    loginAndCreateAdminAccount: function () {
      // Emit login event, that would submit the signin form
      // if menu is empty allow to try to create an admin
      if (this.$store.state.showCreateAdminLink) eventBus.submitLoginForm(true);
      else eventBus.submitLoginForm(this.isDemo);
      this.isLoginEnabled = false;
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("login-email-valid", function (isValid) {
      self.isLoginEnabled = isValid;
    });
    eventBus.$on("magic-link-sent", function () {
      self.isLoginEnabled = false;
    });
  },
};
</script>

<style>
</style>